export default {"src":"https://web.cdn.greenlight.com/2.1280.0/_next/static/media/plans-star.b8c579af.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};